import { Chart } from 'chart.js';
import { ChartIndicatorLine } from './ChartIndicatorLine';
import { LiveChip } from './LiveChip';

const LIVE_LINE_ID = 'live-indicator';
const LIVE_LINE_COLOR = 'var(--color-primary)';

export const LiveDataLine = ({
  chart,
  dataIndex,
  left,
  chipLabel,
  hideChip = false,
}: {
  chart: Chart;
  dataIndex: number;
  /** Horizontal center of the chip, in canvas pixels. */
  left: number;
  chipLabel: string;
  hideChip?: boolean;
}) => (
  <>
    <ChartIndicatorLine chart={chart} id={LIVE_LINE_ID} dataIndex={dataIndex} color={LIVE_LINE_COLOR} />
    {!hideChip && (
      <div
        className='absolute pointer-events-none flex justify-center'
        style={{ left, top: 0, transform: 'translateX(-50%)' }}
      >
        <LiveChip label={chipLabel} />
      </div>
    )}
  </>
);
